import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';
import gridStyles from 'src/shared/theme/grid.module.scss';
import RoundedButton from 'src/shared/components/RoundedButton';
import Image from 'src/shared/components/Image';

interface Props {
    title: string;
    description: string | React.ReactElement;
    buttonText: string;
    type: 'rightChart' | 'leftChart';
    chartSrc: string;
    onClick?: () => void;
}

const ChartWithDescription = (props: Props) => {
    return (
        <div
            className={classnames(gridStyles.container, styles.container, {
                [styles.rightChart]: props.type === 'rightChart',
                [styles.leftChart]: props.type === 'leftChart',
            })}
        >
            <div className={classnames(gridStyles.lg6)}>
                <p className={styles.title}>{props.title}</p>
                <p className={styles.description}>{props.description}</p>
                <RoundedButton className={styles.viewButton} type="primary-on-dark" onClick={props.onClick}>
                    {props.buttonText}
                </RoundedButton>
            </div>
            <div className={classnames(gridStyles.lg6)}>
                <Image src={props.chartSrc} />
            </div>
        </div>
    );
};

ChartWithDescription.defaultProps = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick: () => {},
};

export default ChartWithDescription;
